

/** 用于广点通的 tracking */
export default () => async (params) => {
    const { eventType, info = {} } = params
    if (typeof(gdt) != 'undefined' && typeof(gdt) == 'function') {
        gdt('track', eventType, info)
    }
}
